// frontend/src/features/chat/components/rich-blocks/PhaseTimeline.tsx

import { parseTimelineBlocks } from "./parse";
import { EntityChip } from "../EntityChip";

const ENTITY_URL_PATTERN =
  /(?:map\.combify\.com|staging\.eu-west-1\.combify\.com|localhost(?::\d+)?)\/(property|project|permit|tender)\/([^\s)]+)/;

interface PhaseTimelineProps {
  content: string;
  onEntityClick?: (entityType: string, entityId: string, name: string) => void;
}

export function PhaseTimeline({ content, onEntityClick }: PhaseTimelineProps) {
  const blocks = parseTimelineBlocks(content);
  if (blocks.length === 0) return null;

  return (
    <div className="cx-timeline">
      {blocks.map((block, bi) => {
        const currentIdx = block.phases.findIndex((p) => p.isCurrent);

        return (
          <div key={bi} className="cx-timeline-block">
            <div className="cx-timeline-name">
              {block.link && onEntityClick ? (() => {
                const entityMatch = block.link!.url.match(ENTITY_URL_PATTERN);
                if (entityMatch) {
                  return (
                    <EntityChip
                      entityType={entityMatch[1]!}
                      entityId={entityMatch[2]!}
                      onClick={onEntityClick}
                    >
                      {block.name}
                    </EntityChip>
                  );
                }
                return <span>{block.name}</span>;
              })() : (
                <span>{block.name}</span>
              )}
            </div>
            <div className="cx-timeline-phases">
              {block.phases.map((phase, pi) => {
                let stateClass = "cx-timeline-phase--future";
                if (phase.isCurrent) {
                  stateClass = "cx-timeline-phase--current";
                } else if (currentIdx >= 0 && pi < currentIdx) {
                  stateClass = "cx-timeline-phase--complete";
                } else if (currentIdx === -1) {
                  stateClass = phase.isForecasted ? "cx-timeline-phase--future" : "cx-timeline-phase--complete";
                }

                return (
                  <div
                    key={pi}
                    className={`cx-timeline-phase ${stateClass}`}
                  >
                    <div className="cx-timeline-phase-name">{phase.name}</div>
                    <div className={`cx-timeline-phase-date${phase.isForecasted ? " cx-timeline-phase-date--forecasted" : ""}`}>
                      {phase.date}
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        );
      })}
    </div>
  );
}
